import { render, staticRenderFns } from "./AppAniversariantes.vue?vue&type=template&id=54735a80&"
import script from "./AppAniversariantes.vue?vue&type=script&lang=js&"
export * from "./AppAniversariantes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports